export default __webpack_public_path__ + "static/media/men.50ffaa34.png";